import React from "react";
import AboutMe from "./AboutMe";
import Interests from "./Interests";

function About(){
    return(
        <>
            <AboutMe />
            <Interests />
        </>
    );
}
export default About;